import { Link } from "react-router-dom";
import "./contactUs.css";
import { ToastContainer, toast } from "react-toastify";
import "../assets/ReactToastify.css";

function ContactUs() {
  const notify = () => {
    toast.info(
      "This was added only for design purposes, no functionalities included.",
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }
    );
  };

  return (
    <section id="contact-us" className="contact-us section wow fadeInUp">
      <div className="container">
        <div className="contact-head">
          <div className="row">
            <div className="col-12">
              <div className="d-flex flex-row"></div>
              <div className="section-title">
                <h2 className="fw-400 fs-2">Contact Us</h2>
                {/*<div className="containerbar">
                  <iframe
                    src="https://my.spline.design/untitled-97b7fca299d6abc44549a46568d91536/"
                    frameborder="0"
                    width="50%"
                    height="100%"
                  ></iframe>
  </div>*/}
              </div>
            </div>
          </div>
          <div className="class"></div>
          <div className="contact-info">
            <div className="row">
              <div className="col-lg-4 col-md-12 col-12">
                <div className="single-info-head">
                  <div className="single-info">
                    <i className="fa-regular fa-map fs-4 mb-10"></i>
                    <h5>Address</h5>
                    <ul>
                      <li className="text-secondary">
                        Bahnhofstrasse 106, 8001
                        <br /> Zürich, Suiza
                      </li>
                    </ul>
                  </div>
                  <br />
                  <div className="single-info">
                    <i className="fa-regular fa-envelope fs-4 mb-10"></i>
                    <h5>Mail at</h5>
                    <ul>
                      <li>
                        <Link
                          className="text-secondary text-decoration-none"
                          to="#"
                        >
                          laderhack@project.com
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-md-12 col-12">
                <div className="contact-form-head">
                  <div className="form-main">
                    <form
                      action="#"
                      className="form"
                      onSubmit={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                          <input
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder="Your Name"
                            aria-label="First name"
                          />
                        </div>
                        <div className="col-lg-6 col-md-6 col-12">
                          <input
                            name="your-subject"
                            type="text"
                            className="form-control"
                            placeholder="Your Subject"
                            aria-label="Your Subject"
                          />
                        </div>
                        <div className="col-lg-6 col-md-6 col-12">
                          <input
                            name="email"
                            type="text"
                            className="form-control"
                            placeholder="Your Email"
                            aria-label="Your Email"
                          />
                        </div>
                        <div className="col-lg-6 col-md-6 col-12">
                          <input
                            name="phone"
                            type="tel"
                            className="form-control"
                            placeholder="Your Phone"
                            aria-label="Your Phone"
                          />
                        </div>

                        <div className="col-12">
                          <div className="mb-3">
                            <textarea
                              className="form-control"
                              name="message"
                              rows="3"
                              placeholder="Your Message"
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group button">
                            <button
                              onClick={notify}
                              type="submit"
                              className="btn"
                            >
                              Submit Message
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
